import { useEffect } from 'react';

import { useFeatureHints } from 'components/shared/feature-hints';

import { useMonitoringTourStart } from 'containers/user/critical-elements-monitoring/hooks/use-monitoring-tour-start';

export interface MonitoringTourStartTriggerProps {
  isReady: boolean;
  isActive: boolean;
  isAnalyticsEnabled: boolean;
  oktaUserId: string | undefined;
}

const MonitoringTourStartTrigger = ({
  isReady,
  isActive,
  isAnalyticsEnabled,
  oktaUserId,
}: MonitoringTourStartTriggerProps) => {
  const { activeId, start, close } = useFeatureHints();

  useEffect(() => {
    if (!isActive && activeId !== null) close();
  }, [isActive, activeId, close]);

  useMonitoringTourStart({
    isReady: isReady && isActive,
    isAnalyticsEnabled,
    oktaUserId,
    activeId,
    start,
  });

  return null;
};

export default MonitoringTourStartTrigger;
